import React from 'react';
import { Card, CardProps } from 'pounceV2';
import DetectionFieldFiltersFormV3 from 'Components/forms/DetectionFieldFiltersForm/DetectionFieldFiltersFormV3';

interface EditDetectionFilterFieldsCardProps extends CardProps {
  disabled?: boolean;
}

const EditDetectionFilterFieldsCardV3: React.FC<EditDetectionFilterFieldsCardProps> = ({
  disabled,
  ...rest
}) => (
  <Card
    variant="inverseRaisedToBrand"
    borderWidth={0}
    {...rest}
    sx={{ opacity: disabled ? 0.4 : 1, overflow: 'visible' }}
  >
    <DetectionFieldFiltersFormV3 />
  </Card>
);

export default React.memo(EditDetectionFilterFieldsCardV3);
